import React from 'react';
import { ArrowRight, CheckCircle } from 'lucide-react';
import Button from '../Common/Button';
import { ServicoItem } from './services.types';

interface Props {
  servico: ServicoItem;
  onClickContratar?: (key: ServicoItem['key']) => void;
}

const ServicoCard: React.FC<Props> = ({ servico, onClickContratar }) => {
  const Icon = servico.icon;

  return (
    <div className="bg-color-background border border-color-border rounded-lg overflow-hidden hover:shadow-lg transition-all">
      {/* Header */}
      <div className="bg-gradient-to-r from-color-primary/10 to-color-secondary/10 border-b border-color-border p-6">
        <div className="flex items-center gap-4 mb-3">
          <div className="w-12 h-12 bg-color-primary/20 rounded-lg flex items-center justify-center">
            <Icon className="text-color-primary" size={24} />
          </div>
          <h3 className="text-xl font-bold text-color-text">{servico.titulo}</h3>
        </div>
        <p className="text-color-text-secondary">{servico.desc}</p>
      </div>

      {/* Content */}
      <div className="p-6 space-y-6">
        <ul className="space-y-3">
          {servico.features.map((feature, fIdx) => (
            <li key={fIdx} className="flex items-start gap-3">
              <CheckCircle size={18} className="text-color-success flex-shrink-0 mt-0.5" />
              <span className="text-color-text-secondary text-sm">{feature}</span>
            </li>
          ))}
        </ul>

        <div className="pt-6 border-t border-color-border flex items-center justify-between">
          <span className="text-2xl font-bold text-color-primary">{servico.preco}</span>

          <Button
            variant="primary"
            onClick={() => onClickContratar?.(servico.key)}
          >
            Contratar
            <ArrowRight size={16} />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ServicoCard;
